// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from '@/App'
import router from '@/router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import Vuex from 'vuex'
import store from './store/index'
import httpRequest from '@/utils/httpRequest' // api: https://github.com/axios/axios
import { isAuth } from '@/utils'
import preventReClick from '@/utils/preventReClick'
import VueCookie from 'vue-cookie'
import '../static/css/global.css'

Vue.use(VueCookie)
Vue.use(ElementUI)
Vue.config.productionTip = false

// 挂载全局
Vue.prototype.$http = httpRequest // ajax请求方法
Vue.prototype.isAuth = isAuth     // 权限方法


router.beforeEach((to, from, next) => {
	let flag = to.meta.requireAuth;
	let token = Vue.cookie.get('uuid');
	let isPass = Vue.cookie.get('is_pass')

	if(to.fullPath === '/login') {
		if(token) {
			// 如果已经登录，但不是从注册或找回密码页面跳转过来的，则重定向到首页
			if (from.fullPath !== '/register' && from.fullPath !== '/findPsw') {
				next("/")
			} else {
				next();
			}
		} else {
			next();
		}
	} else {
		if (flag) {  // 判断该路由是否需要登录权
			if (token) {
				if(isPass == 2) {
					next()
				} else {
					if(to.fullPath === '/addInfo') next();
					else next('/addInfo')
				}
			} else {
				// 未登录,跳转到登陆页面
				next( {name: 'login'} )
			}
		} else {
			next();
		}
	}
})

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	components: { App },
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js